import React from "react";

/**
 * Events hero — design/stitch/events.html + events.png
 */
const Herosection = () => {
  return (
    <section
      className="relative pt-12 sm:pt-14 pb-10 sm:pb-12 overflow-hidden text-left"
      style={{
        background:
          "linear-gradient(to bottom, color-mix(in srgb, var(--color-cloud-mist) 40%, var(--color-white)), var(--color-surface-light), var(--color-white))",
      }}
    >
      <div
        className="absolute top-6 left-8 sm:left-12 w-40 sm:w-48 h-40 sm:h-48 rounded-full blur-3xl pointer-events-none"
        style={{
          backgroundColor:
            "color-mix(in srgb, var(--color-cloud-mist) 60%, transparent)",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute top-12 right-10 sm:right-20 w-52 sm:w-64 h-52 sm:h-64 rounded-full blur-3xl pointer-events-none"
        style={{
          backgroundColor:
            "color-mix(in srgb, var(--color-sunshine) 25%, transparent)",
        }}
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 relative z-10">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-cloud-mist text-spectrum-blue text-xs font-headline font-semibold">
            <svg
              className="w-4 h-4 text-heart-teal shrink-0"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 21C12 21 6 16.5 6 11C6 7.5 8.5 5 12 5C15.5 5 18 7.5 18 11C18 16.5 12 21 12 21Z"
              />
            </svg>
            Community Gatherings
          </span>
        </div>

        <h1 className="font-headline text-[1.75rem] sm:text-4xl lg:text-5xl tracking-tight mb-2 text-ink">
          <span className="font-light">Our </span>
          <span className="font-extrabold text-spectrum-blue">Events</span>
        </h1>

        <p className="font-accent-hand text-[20px] sm:text-[22px] leading-snug text-heart-teal mb-3">
          Safe, welcoming gatherings for every family
        </p>

        <p className="font-body text-[15px] sm:text-base md:text-lg text-muted max-w-2xl leading-relaxed mb-6">
          Join us for calm, sensory-friendly community gatherings where every
          neurodivergent child and family belongs.
        </p>

        <div className="bg-surface-white border border-hairline rounded-brand p-4 flex items-start sm:items-center gap-3 sm:gap-4 max-w-3xl shadow-brand-sm">
          <div className="w-10 h-10 rounded-brand bg-cloud-mist flex items-center justify-center text-spectrum-blue shrink-0">
            <svg
              fill="none"
              viewBox="0 0 24 24"
              width="22"
              height="22"
              stroke="currentColor"
              strokeWidth="1.75"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                d="M12 3c-1.5 4-4 6.5-4 9a4 4 0 0 0 8 0c0-2.5-2.5-5-4-9zM9 20h6"
              />
            </svg>
          </div>
          <p className="font-headline text-xs sm:text-sm text-ink leading-relaxed">
            <strong className="text-spectrum-blue font-bold">
              Every event includes:
            </strong>{" "}
            Quiet sensory decompression zones, trained peer support volunteers,
            and gentle, flexible participation at your child&apos;s pace.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Herosection;
